import React from "react";
import { CardHeader, Card, CardBody, CardTitle } from "reactstrap";
import "assets/scss/custom.scss";
import { FaTrashAlt } from "react-icons/fa";
import ItemCounter from "../AddOrder/ItemCounter";

const OfferCard = ({ offer, handleRemoveItem }) => {
  return (
    <Card
      className="w-100 h-100 border border-gray position-relative bg-secondary"
      style={{ boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)" }}
    >
      <div
        className="d-flex justify-content-center align-items-center position-absolute cursor-pointer bg-white"
        style={{
          width: "25px",
          height: "25px",
          borderRadius: "9999px",
          top: "-10px",
          right: "-10px",
          boxShadow: "0 0 6px rgba(0, 0, 0, 0.5)",
        }}
        onClick={() => {
          handleRemoveItem(offer?.orderItemID);
        }}
      >
        <FaTrashAlt size={13} className="text-danger" />
      </div>
      <CardHeader
        className="relative w-100 p-0 overflow-hidden"
        style={{ height: "150px" }}
      >
        <img
          src={
            offer?.images ||
            "https://res.cloudinary.com/dzhvjtoot/image/upload/v1712309249/logo/ogb3puh0buzqtzem3ce1.png"
          }
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
          alt="offer img"
        />
      </CardHeader>
      <CardBody className="d-flex flex-column justify-content-between custom-cardBody-padding bg-secondary">
        <div>
          <CardTitle className="fs--14 fw--700  mb-0 p-0">
            {offer?.name}
          </CardTitle>
        </div>
        <div className="mt-2 py-1 border-top border-bottom border-lighter">
          <div
            className="px-0"
            style={{
              maxHeight: "80px",
              overflowY: "auto",
              paddingRight: "0.5rem",
            }}
          >
            {offer?.cartItems?.map((item, idx, array) => (
              <div
                key={idx}
                className="d-flex align-items-center mx-0 my-0 w-100"
                style={{
                  borderBottom:
                    idx < array.length - 1 ? "1px dashed #e0e0e0" : "none",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  minHeight: "60px",
                }}
              >
                <img
                  src={item?.image}
                  alt={item?.itemName}
                  style={{
                    width: "45px",
                    height: "45px",
                    objectFit: "cover",
                    borderRadius: "0.5rem",
                    marginRight: "10px",
                    boxShadow: "0 0 4px rgba(0,0,0,0.05)",
                  }}
                />
                <div className="flex-grow-1">
                  <div className="fw-semibold text-dark text-truncate fs--14">
                    {item?.itemName}
                  </div>
                  <div className="small text-muted fs--14">
                    {item?.variant && `Variant: ${item.variant}`}
                  </div>
                  <div className="small text-muted fs--14">
                    {item?.quantity && `Quantity: ${item.quantity}`}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="fs--14 w-100 d-flex flex-row justify-content-between mt-2">
          <div className="fw--400">Price:</div>
          <div className="fw--400">
            {offer?.currency}&nbsp;{offer?.price}
          </div>
        </div>
        <div className="fs--14 w-100 d-flex flex-row justify-content-between mt-2">
          <div className="fw--400">Total:</div>
          <span className="custom-price-color fw--14 fw--600">
            {offer?.currency || "$"}&nbsp;{offer?.totalPrice}
          </span>
        </div>

        <ItemCounter orderItem={offer} />
      </CardBody>
    </Card>
  );
};

export default OfferCard;
